import React from 'react';
import BaseCreatePage from '../../_CustomComponents/BaseCreatePage';
import { connect } from "react-redux";
import PortletSpinner from '../../../../partials/layout/PortletSpinner';
import { Portlet, PortletBody, PortletHeader } from "../../../../partials/content/Portlet";
import { Alert } from "react-bootstrap";
import * as taskOrderCrud from '../../../../crud/taskOrder.crud';
import * as requestForQuoteCrud from '../../../../crud/requestForQuote.crud';
import * as rfqQuotationCrud from '../../../../crud/rfqQuotation.crud';
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import moment from 'moment';
import { FormattedMessage } from "react-intl";
import { withCreatePageProps } from '../../../../shared/hoc/withCreatePageProps';
import Common from '../../../../shared/common';
import { actionCodes } from "../../../../shared/lookup";
class TaskCreatePage extends BaseCreatePage {
    constructor(props) {
        super(props);
        const { subject } = ((props.location.state || {}).itemCustomProps || {});
        const { state } = props.location;
        this.createDefaultSubject = subject;
        this.createDefaultFields = state;

        this.state = {
            showAlert: true,
            formFields: null
        };
    }
    fetchRelatedQuotation = async (requestforquoteid) => {
        try {
            const { data: relatedAcceptedQuote } = await rfqQuotationCrud.getAcceptedQuotation(requestforquoteid);
            return relatedAcceptedQuote;
        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            return null
        }
    }

    setFormFields = async () => {
        const { fields } = this.props.workflowItem;
        let relatedQuotation = null;
        let defaultRfqSelection = null;

        if (fields.RfqRelation.visible && this.createDefaultFields?.itemBaseProps?.reftype === 'Rfq' && this.createDefaultFields?.itemBaseProps?.refid) {
            //create page, redirected from create related button
            relatedQuotation = await this.fetchRelatedQuotation(this.createDefaultFields?.itemBaseProps?.refid);
            //AUTO-SELECT RFQ DROPDOWN (IF REDIRECTED FROM CREATE-RELATED BUTTON)
            defaultRfqSelection = Number(this.createDefaultFields.itemBaseProps.refid);
        }
        const defaultSubjectToUse = relatedQuotation?.subject || this.createDefaultSubject;
        const formFields = {
            currencyCode: this.props.contract.currency,
            buttonResource: "GENERAL.FORMS.BUTTON_CREATE_DRAFT",
            fields: [
                { resource: 'GENERAL.FORMS.FIELD.SUBJECT', dataField: 'subject', editorOptions: { defaultValue: defaultSubjectToUse } },
                { note: this.props.resources.Note }
            ]
        };

        if (fields.RfqRelation.visible) {
            formFields.fields.push({ label: fields.RfqRelation.label, dataField: 'requestforquoteid', required: fields.RfqRelation.required, editorType: 'dxSelectBox', editorOptions: { dataSource: this.getRFQsDataSourceOptions(), valueExpr: 'value', displayExpr: 'display', defaultValue: defaultRfqSelection } });
        }

        if (fields.Description.visible) {
            formFields.fields.push({ label: fields.Description.label, dataField: 'description', editorType: 'dxHtmlEditor', editorOptions: { defaultValue: relatedQuotation?.description } })
        }
        if (fields.Comments.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultCommentsValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.comments;
            formFields.fields.push({ label: fields.Comments.label, dataField: 'comments', editorType: 'dxHtmlEditor', editorOptions: { defaultValue: defaultCommentsValue } })
        }
        if (fields.ItemsList.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultItemsListValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.itemslist;
            formFields.fields.push({ label: fields.ItemsList.label, dataField: 'pricelistdescription', editorOptions: { defaultValue: defaultItemsListValue } })
        }
        if (fields.TotalListPrice.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultTotalListPriceValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.totallistprice;
            formFields.fields.push({ label: fields.TotalListPrice.label, dataField: 'pricelisttotal', editorType: 'dxNumberBox', editorOptions: { defaultValue: defaultTotalListPriceValue } })
        }
        if (fields.CompensationDescription.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultCompensationDescriptionValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.requestforquotedescription;
            formFields.fields.push({ label: fields.CompensationDescription.label, dataField: 'compensationeventdescripton', editorOptions: { defaultValue: defaultCompensationDescriptionValue } })
        }
        if (fields.TotalAssessed.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultTotalAssessedValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.totalassessed;
            formFields.fields.push({ label: fields.TotalAssessed.label, dataField: 'compensationeventtotal', editorType: 'dxNumberBox', editorOptions: { defaultValue: defaultTotalAssessedValue } })
        }
        if (fields.TotalPrice.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultTotalPriceValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.totalprice;
            formFields.fields.push({ label: fields.TotalPrice.label, dataField: 'taskordertotal', editorType: 'dxNumberBox', value: this.calculateTotal, editorOptions: { defaultValue: defaultTotalPriceValue } })
        }
        if (fields.StartDate.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultStartDateValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.startdate;
            formFields.fields.push({ label: fields.StartDate.label, dataField: 'startdate', editorType: 'dxDateBox', editorOptions: { defaultValue: defaultStartDateValue } });
        }
        if (fields.CompletionDate.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultCompletionDateValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.completiondate;
            const completionDateField = { label: fields.CompletionDate.label, dataField: 'completiondate', editorType: 'dxDateBox', editorOptions: { defaultValue: defaultCompletionDateValue }, validation: { type: 'range', min: new Date(1900, 0, 1), max: new Date(2079, 5, 6), warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.INVALID_DATE" }) } }
            if (fields.StartDate.visible) {
                completionDateField.validation = { type: 'custom', validationCallback: (obj, value) => (obj.startdate <= value), warning: 'Completion date can not be earlier than start date' }
            }
            formFields.fields.push(completionDateField);
        }
        if (fields.DelayAmount.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultDelayAmountValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.delayamount;
            formFields.fields.push({ label: fields.DelayAmount.label, dataField: 'delaydamagestotal', editorType: 'dxNumberBox', editorOptions: { defaultValue: defaultDelayAmountValue } })
        }
        if (fields.DelayPaymentPeriod.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultDelayPaymentPeriodValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.delaypaymentperiod;
            formFields.fields.push({ label: fields.DelayPaymentPeriod.label, dataField: 'delaydamagestype', editorType: 'dxSelectBox', editorOptions: { dataSource: this.props.paymentPeriods, defaultValue: defaultDelayPaymentPeriodValue } })
        }

        this.setState({ formFields });

    }
    calculateTotal = (obj) => {
        const prc1 = obj.pricelisttotal ? obj.pricelisttotal : 0;
        const prc2 = obj.compensationeventtotal ? obj.compensationeventtotal : 0;
        return prc1 + prc2;
    }
    getRFQsDataSourceOptions = () => {
        const { companyid, projectid, contractid } = this.props.contract;
        const toStates = ['APMA', 'ARQ', 'APMRQ', 'AQ', 'QA', 'APMR'];
        const datasource = {
            loadMode: 'raw',
            cacheRawData: true,
            load: () => {
                var promise = new Promise(async (resolve) => {
                    const { data: responseObj } = await requestForQuoteCrud.getContractRequestForQuotes(companyid, projectid, contractid);
                    let RFQs = responseObj.aggregatelist.filter(ntf => {
                        if (toStates.includes(ntf.status)) {
                            return true;
                        }
                        else return false;
                    }).map(itm => {
                        return {
                            value: itm.requestforquoteid,
                            reference: itm.referenceid,
                            title: itm.subject,
                            display: `${itm.referenceid}   {${itm.subject}}`
                        }
                    });
                    resolve(RFQs);
                });
                return promise;
            }
        }
        return datasource;
    }

    submitHandler = (task) => {
        task.companyid = this.props.contract.companyid;
        task.contractid = this.props.contract.contractid;
        task.projectid = this.props.contract.projectid;
        if (task.startdate) {
            task.startdatedisplay = moment(task.startdate).format('DD/MM/YYYY');
        }
        if (task.completiondate) {
            task.completiondatedisplay = moment(task.completiondate).format('DD/MM/YYYY');
        }

        task.status = 'Not Communicated';
        task.actioncode = actionCodes.CREATE;
        task.workflowid = this.props.workflowItem.id;
        this.appendRelationship(task);
        Common.PropertyConversionsBeforeNoticeSaveRequest(task, this.props.customFields, this.props.contractUsers);
        taskOrderCrud.saveTaskOrder(task)
            .then(response => {
                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.DRAFT_SUCCESS' }), { variant: 'success', });
                try {
                    const createdID = Number(response.data);
                    this.props.navigate(this.props.workflowItem.paths.basePath + createdID);
                }
                catch {
                    this.props.navigate(this.props.workflowItem.paths.listPath);
                }
            })
            .catch(err => {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', key: "PersistentFormWarning", persist: true });
            });
    }

    componentDidMount() {
        this.setFormFields();
    }

    render() {
        if (!this.state.formFields) {
            return (<PortletSpinner />);
        }
        const { assetid } = ((this.props.location.state || {}).itemCustomProps || {});

        return (
            <Portlet>
                <PortletHeader title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.CREATE_TITLE' }, { ITEM_NAME: this.props.workflowItem.pageTitle })} />
                <PortletBody style={{ maxWidth: 1000 }}>
                    {this.state.showAlert && (
                        <Alert variant="secondary" onClose={() => this.setState({ showAlert: false })} dismissible>
                            <p>
                                <FormattedMessage id="GENERAL.FORMS.WARNING_DRAFT" />
                            </p>
                        </Alert>
                    )}
                    {this.props.resources.WarningBanner && (
                        <Alert variant="warning" >
                            <p>
                                {this.props.resources.WarningBanner}
                            </p>
                        </Alert>
                    )}
                    <BiDynamicForm
                        onSubmitHandler={this.submitHandler}
                        config={this.state.formFields}
                        customFields={(this.props.customFields || {}).COMMUNICATION}
                        assetFieldsEnabled={this.props.workflowItem.assetFieldsEnabled}
                        assetid={assetid}
                    />

                </PortletBody>
            </Portlet>
        );
    }
}

const mapStateToProps = store => ({
    contractUsers: store.contract.users
});

export default withCreatePageProps(connect(mapStateToProps)(TaskCreatePage));
